<ion-header *ngIf="false">
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content [scrollEvents]="true">
  
  <bloc-header-comp *ngIf="activeStep === 3 && !displayErrorSecureId && !displayErrorEmpty" [compOptions]="{'title': blocHeaderTitle, 'isBackBtn': true, 'url': blocHeaderBackUrl}"></bloc-header-comp>

  <div class="eligibilite-cpf">
    <div *ngIf="!isDesktop" class="slider">
      <div [appSlider]="{inline: true, bounce: true, startAt: activeStep}">
        <div class="step-container" [style.width.px]="step.mobileWidth" *ngFor="let step of eligibiliteCPFSteps; let ixs = index">
          <div class="step" [ngClass]="{'done': step.step < activeStep, 'ongoing': step.step == activeStep, 'inactive': step.step > activeStep}">
            <img *ngIf="step.step < activeStep" [src]="'assets/2022/icons/' + step.icon + '-green.svg'" alt="EnvoitureSimone">
            <img *ngIf="step.step == activeStep" [src]="'assets/2022/icons/' + step.icon + '-blue.svg'" alt="EnvoitureSimone">
            <img *ngIf="step.step > activeStep" [src]="'assets/2022/icons/' + step.icon + '.svg'" alt="EnvoitureSimone">
            <div class="txt">{{step.text}}</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isDesktop" class="slider">
      <div class="step-container" *ngFor="let step of eligibiliteCPFSteps; let ixs = index">
        <div class="step" [ngClass]="{'done': step.step < activeStep, 'ongoing': step.step == activeStep, 'inactive': step.step > activeStep}">
          <img *ngIf="step.step < activeStep" [src]="'assets/2022/icons/' + step.icon + '-green.svg'" alt="EnvoitureSimone">
          <img *ngIf="step.step == activeStep" [src]="'assets/2022/icons/' + step.icon + '-blue.svg'" alt="EnvoitureSimone">
          <img *ngIf="step.step > activeStep" [src]="'assets/2022/icons/' + step.icon + '.svg'" alt="EnvoitureSimone">
          <div class="txt">{{step.text}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="initPageDone && eligibiliteCPFCurrentStep?.gearbox_type && !displayErrorSecureId && !displayErrorEmpty" class="sub-header">
      <p>Ta demande de formation CPF</p>
      <p *ngIf="eligibiliteCPFCurrentStep.gearbox_type === 'bva'" class="tag bva">Boîte automatique</p>
      <p *ngIf="eligibiliteCPFCurrentStep.gearbox_type === 'bvm'" class="tag bvm">Boîte manuelle</p>
    </div>
    <page-loader-comp *ngIf="!initPageDone"></page-loader-comp>
    <div *ngIf="initPageDone" class="eligibilite-cpf-content max-width-920">
      <div *ngIf="displayErrorSecureId">
        <div class="evs-card-ui text-center">
          <h5>Oups… le numéro d'identification utilisateur n'est pas le bon.</h5>
          <p>Nous t'invitons à vérifier ton numéro d'identifiant dans tes mails.</p>
        </div>
      </div>
      <div *ngIf="displayErrorEmpty">
        <div class="evs-card-ui text-center">
          <h5>Synchronisation des montres ⌚ Euh, loupé 🤓</h5>
          <p>On prépare la page, attends quelques minutes ou repasse un peu plus tard, ça va arriver 💪</p>
        </div>
      </div>

      <div *ngIf="activeStep === 1 && !displayErrorSecureId && !displayErrorEmpty" class="typeform-container">
        <div *ngIf="displayErrorRetry" class="evs-card-ui text-center error-display">
          <h5><img [src]="'assets/2022/icons/danger-off-black.svg'" alt="EnvoitureSimone">Echec de l'envoi du formulaire</h5>
          <p>Une erreur est survenue et nous n'avons malheureusement pas réussi à envoyer ton formulaire. Nous t'invitons à le recompléter afin de te faire une proposition de formation personnalisée. Merci !</p>
        </div>
        <div class="evs-card-ui" id="typeform-eligibilite-cpf"></div>
      </div>

      <div *ngIf="activeStep === 2 && !displayErrorSecureId && !displayErrorEmpty" class="yousign-container">
        <div *ngIf="!displayErrorRetry" class="evs-card-ui text-center">
          <img [src]="'assets/2022/pictos/signature.svg'" class ="signature" alt="EnvoitureSimone">
          <h5>Contrat de formation et attestation sur l'honneur</h5>
          <p>Nous t'invitons à examiner ton contrat de formation et ton attestation sur l'honneur. Il te sera ensuite possible de les signer.</p>
          <button class="btn" (click)="openLink('yousignSignatureLink')">Accéder aux documents</button>
        </div>
        <div *ngIf="displayErrorRetry" class="evs-card-ui text-center error-display">
          <h5><img [src]="'assets/2022/icons/danger-off-black.svg'" alt="EnvoitureSimone">Ta signature n'a pas été prise en compte</h5>
          <p>Une erreur est survenue et nous n'avons malheureusement pas réussi à finaliser la signature de tes documents. Nous t'invitons à les signer à nouveau afin de te faire une proposition de formation personnalisée. Merci !</p>
        </div>
      </div>

      <div *ngIf="activeStep === 3 && !displayErrorSecureId && !displayErrorEmpty" class="recap-container">
        <div class="evs-card-ui text-center">
          <ng-container *ngIf="recapSubStep === 1">
            <img [src]="'assets/2022/illustrations/not-cpf-eligible.svg'" class ="recap-illu-not-eligible" alt="EnvoitureSimone">
            <h5>Oh non, tu n'es pas éligible à notre formation CPF</h5>
            <p>Tu as fait une erreur ?<br/>N'hésite pas à refaire une demande sur ton compte formation.</p>
            <button class="btn" (click)="openLink('myTrainingAccount')">Je refais une demande</button>
            <p>Tu as une question ? Notre équipe est là pour toi.</p>
            <a *ngIf="!isPlatformDesktop" class="call-center-link small-clickable" [href]="'tel:' + callCenterPhoneFormatted">
              <img [src]="'assets/svg/picto_call.svg'" alt="EnvoitureSimone">{{ callCenterPhone }}
            </a>
          </ng-container>

          <ng-container *ngIf="recapSubStep === 2">
            <img [src]="'assets/2022/illustrations/cpf-eligible.svg'" class ="recap-illu-eligible" alt="EnvoitureSimone">
            <h5>Tu es éligible à notre formation CPF</h5>
            <p>Plus qu'une dernière étape avant de démarrer :</p>
            <p class="highlight"><img [src]="'assets/2022/icons/arrow-right-square-on.svg'" alt="EnvoitureSimone">Rends-toi sur ton compte formation afin de valider notre proposition</p>
            <button class="btn" (click)="openLink('myTrainingAccount')">Mon compte formation</button>
          </ng-container>

          <ng-container *ngIf="recapSubStep === 3">
            <img [src]="'assets/2022/illustrations/cpf-eligible.svg'" class ="recap-illu-eligible" alt="EnvoitureSimone">
            <h5>Tu es éligible à notre formation CPF</h5>
            <p>Nous te confirmons que ta demande de formation est bien enregistrée ! Nous t'invitons à regarder dans tes mails afin d'avoir plus d'informations sur la date de début de ta formation.</p>
            <button class="btn" (click)="openLink('myTrainingAccount')">Mon compte formation</button>
          </ng-container>

          <ng-container *ngIf="recapSubStep === 4">
            <img [src]="'assets/2022/illustrations/cpf-canceled.svg'" class ="recap-illu-canceled" alt="EnvoitureSimone">
            <h5>Ta demande de formation CPF a été annulée</h5>
            <p>Tu as fait une erreur ?<br/>N'hésite pas à refaire une demande sur ton compte formation.</p>
            <button class="btn" (click)="openLink('myTrainingAccount')">Je refais une demande</button>
            <p>Tu as une question ? Notre équipe est là pour toi.</p>
            <a *ngIf="!isPlatformDesktop" class="call-center-link small-clickable" [href]="'tel:' + callCenterPhoneFormatted">
              <img [src]="'assets/svg/picto_call.svg'" alt="EnvoitureSimone">{{ callCenterPhone }}
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

</ion-content>

<ion-footer *ngIf="false">
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>